import './style.css';
import pdf from "../../assets/pdf/marche_a_suivre_activite_3.pdf";
import excel from "../../assets/excel/excel.xlsx";
import phoenixLogo from "../../assets/phoenix_logo.png";
import logo_1 from "../../assets/logos/logo_1.jpg";
import logo_2 from "../../assets/logos/logo_2.jpg";
import logo_3 from "../../assets/logos/logo_3.jpg";
import logo_4 from "../../assets/logos/logo_4.jpg";

function Documents() {
    return (
        <>
            <div id="documents">
                <div className="documents-container">
                    <h1>DOCUMENTS UTILES</h1>
                    <br/>
                    <p style={{color: 'white', textAlign: 'center', width: '80%', margin: 'auto'}}>
                        Vous trouverez ci-dessous quelques informations pratiques pour l'organisation des activités, et ensuite des soirées, le listing avec les coordonnées des membres ainsi que les logos à utiliser sur les invitations.
                    </p>
                    <br/>
                    <div id="files-section">
                        <div className="files">
                            <p>Activité : Marche à suivre</p>
                            <a href={pdf} target="_blank">
                                <img src="https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg" alt="pdf-icon"/>
                            </a>
                        </div>
                        <div className="files">
                            <p>Listing Membres</p>
                            {/*{/*href={excel} download*/}
                            <a href={"https://docs.google.com/spreadsheets/d/1mAGdoHklI2Lvhde5Xk7EMS4TmEuLf5kP/export?format=xlsx"}>
                                <img src="https://upload.wikimedia.org/wikipedia/commons/e/e3/Microsoft_Office_Excel_%282019%E2%80%932025%29.svg" alt="excel-icon"/>
                            </a>
                        </div>
                    </div>
                    <br/>
                    <p style={{color: '#ffa7a7', textAlign: 'center', fontSize: '14px', width: '80%', margin: 'auto', fontStyle: 'italic'}}>
                        Pour rappel, le listing est strictement réservé à un usage interne, conformément au Règlement général sur la protection des données (RGPD).
                    </p>
                </div>

                <br/><br/>

                <div className="documents-container">
                    <h1>LOGOS</h1>
                    <br/>
                    <p style={{color: 'white', textAlign: 'center', marginBottom: '20px'}}>
                        Logos Phoenix à utiliser pour vos invitations :
                    </p>
                    <div id="logos-section">
                        <div className="logos-double">
                            <a href={logo_1} download><img src={logo_1} alt="Logo 1"/></a>
                            <a href={logo_3} download><img src={logo_3} alt="Logo 3"/></a>
                        </div>
                        <div className="logos-double">
                            <a href={logo_2} download><img src={logo_2} alt="Logo 2"/></a>
                            <a href={logo_4} download><img src={logo_4} alt="Logo 4"/></a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Documents;